module.exports = __webpack_public_path__ + "h5/img/noCollection.ad7c1108.png";